import React, { useEffect, useState } from "react";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { useDispatch } from "react-redux";
import { setImageModalState } from "../../redux/slices/vehicleFilterSlice";

type CarGalleryProps = {
  img: {
    imageUrl: string;
    videoUrl: string;
  }[];
};

interface tag {
  tag: string;
  url: string;
}
const CarGallery: React.FC<CarGalleryProps> = ({ img }) => {
  const [images, setImages] = useState<tag[]>([]);
  const [currentImage, setCurrentImage] = useState<tag>();

  const dispatch = useDispatch();

  useEffect(() => {
    // setImages(splitStringByComma(img[0]?.imageUrl));
    // setImages(img.map((image) => image.imageUrl));
    const imgArr = img.filter((image) => image.imageUrl);
    const imgMap = imgArr.map((image) => image.imageUrl);
    const videoArr = img.filter((image) => image.videoUrl);
    const videoMap = videoArr.map((image) => image.videoUrl);
    const imgArrs = new Set(imgMap);
    const videoArrs = new Set(videoMap);
    const imgObj = Array.from(imgArrs).map((url) => ({ tag: "image", url }));
    const videoObj = Array.from(videoArrs).map((url) => ({
      tag: "video",
      url,
    }));

    const combinedArr = imgObj.concat(videoObj);

    // console.log(combinedArr);
    // const allImages = [...imgArr, ...videoArr];
    // setCurrentImage(img[0]?.imageUrl);
    setImages(combinedArr);
    setCurrentImage(combinedArr[0]);
    // console.log("currentImage", combinedArr[0]);
  }, [img]);
  return (
    <div className="w-full flex flex-col h-[500px]  ">
      {img && images?.length > 0 && currentImage && (
        <div className=" flex flex-col  w-full h-full justify-between ">
          {currentImage?.tag === "video" ? (
            <video
              src={ipfsGatewayImage(currentImage?.url ?? "")}
              className="w-full h-[58%] object-cover"
              controls
            />
          ) : (
            <img
              // src={ipfsGatewayImage(images[0])}
              src={ipfsGatewayImage(currentImage?.url ?? "")}
              alt=""
              className={`w-full ${
                images.length > 1 ? "h-[58%]" : "h-[100%]"
              } object-cover`}
              onClick={() => dispatch(setImageModalState(true))}
            />
          )}

          <div className="flex flex-row  w-full h-[40%]   gap-1 items-center  flex-shrink-0 overflow-x-scroll ">
            {images.map((item, index) => {
              if (item.tag === "image") {
                return (
                  <img
                    src={ipfsGatewayImage(item.url)}
                    alt=""
                    className="w-[40%] h-full object-cover flex flex-shrink-0 cursor-pointer"
                    key={index}
                    // onClick={() => setCurrentImage(item)}
                    onClick={() => dispatch(setImageModalState(true))}
                  />
                );
              } else if (item.tag === "video") {
                return (
                  <video
                    src={ipfsGatewayImage(item.url)}
                    className="w-[40%] h-full object-cover flex flex-shrink-0 cursor-pointer"
                    key={index}
                    onClick={() => setCurrentImage(item)}
                    controls
                  />
                );
              }
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CarGallery;
